var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoPharmacy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 800,
    viewBox: "0 0 800 800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1108_9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M695.309 83.9505H272.593C214.866 83.9505 167.901 130.915 167.901 188.642V219.587H39.5062V54.9806C39.5062 44.069 30.6607 35.2275 19.7531 35.2275C8.84543 35.2275 0 44.069 0 54.9806V745.023C0 755.935 8.84543 764.776 19.7531 764.776C30.6607 764.776 39.5062 755.935 39.5062 745.023V580.413H167.901V611.362C167.901 669.088 214.866 716.053 272.593 716.053H695.309C753.035 716.053 800 669.088 800 611.362V188.646C800 130.915 753.035 83.9505 695.309 83.9505ZM39.5062 259.093H167.901V540.903H39.5062V259.093ZM668.97 463.194C668.97 474.106 660.124 482.947 649.217 482.947H566.894V565.27C566.894 576.182 558.048 585.023 547.141 585.023H420.76C409.853 585.023 401.007 576.182 401.007 565.27V482.947H318.684C307.777 482.947 298.931 474.106 298.931 463.194V336.814C298.931 325.902 307.777 317.061 318.684 317.061H401.007V234.734C401.007 223.822 409.853 214.981 420.76 214.981H547.141C558.048 214.981 566.894 223.822 566.894 234.734V317.061H649.217C660.124 317.061 668.97 325.902 668.97 336.814V463.194Z",
    fill: "#062134"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1108_9"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 800,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPharmacy);
export default __webpack_public_path__ + "static/media/ico_pharmacy.db06a1ae2bf743d271e15b4ca62e2155.svg";
export { ForwardRef as ReactComponent };